<template>
  <div class="row mx-0">
    <div class="col-1"></div>
    <div class="col-10">
      <div class="p-0 m-0 mt-4 main-title">警示參數設定</div>
      <div style="margin-top: 2rem">
        <commonQueryInput :inputItems="multiInputItems" :immediateInputValues="true" v-model:getValue="multiInputVal"
          v-model:getImmediateValue="immediateMultiInputVal"></commonQueryInput>
      </div>
      <template v-if="queryStatus">
        <div class="d-flex justify-content-start text-end mt-4" style="color: #707070">
          <div class=" my-auto me-4" style="min-width: max-content;">
            <span>警示燈運作設定</span>
          </div>
          <div class="px-2" style="">
            <div class="d-flex justify-content-start">
              <div v-for="(item, key) in !mod ? alarmSettingData : modAlarmSettingData"
                class="d-flex justify-content-start me-3" style="width:90px">
                <div class="my-auto me-2">
                  {{ item.device_name }}:
                </div>
                <template v-if="!mod">
                  <div class="alarm-light-setting">
                    {{ item.ht_light_setting == "Y" ? "開" : "關" }}
                  </div>
                </template>
                <template v-else>
                  <select class="custom-select"
                    style="max-width: 9rem;width: 144px;height: 2.375rem;font-size: 0.875rem;border: 2px solid rgb(255, 255, 255);box-shadow: rgb(0 0 0 / 20%) 0px 1px 3px 0px;color: rgb(95, 95, 95);"
                    v-model="modAlarmSettingData[key].ht_light_setting" name="commonSelectInput">
                    <option v-for="option in alarmSettingOptions" :value="option.value">
                      {{ option.text }}
                    </option>
                  </select>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between text-end mt-4 mb-2">
          <div class="py-1" style="min-width: max-content;color: #707070;">
            <span>參數條件設定</span>
          </div>
          <div class="py-1 px-2" style="background: #c8c9ca; min-width: max-content">
            <span>異動人員：{{ username }}</span>
          </div>
        </div>
        <commonTable :fields="heatAlarmSettingFields" :items="!mod ? heatAlarmSettingItems : modItems"
          :otherTheme="'thead-green'" :tableStyle="{ color: '#707070' }" stickyHeader="450px">
          <template #cell(condName)="data">
            <template v-if="mod && condOptions[data.item.cond_group_code].type == 'Y'">
              <select class="custom-select"
                style="color: #707070;max-width: 9rem;width: 160px;height: 30px;font-size: 0.875rem;padding-top: 0px;padding-bottom: 0px;"
                v-model="data.item.cond_code" name="commonSelectInput">
                <option v-for="option in condOptions[data.item.cond_group_code].options" :value="option.value">
                  {{ option.text }}
                </option>
              </select>
            </template>
            <template v-else>
              {{ data.value }}
            </template>
          </template>
          <template #cell(value)="data">
            <template v-if="mod && condOptions[data.item.cond_group_code].type == 'Y'">
              <input type="number" min="0" :step="data.item.light_code == 'lt_cp' ? 0.01 : 1" name="heatAlarmValue"
                @blur="checkChangeInput('value', data.index)" v-model="data.item.value"
                style="color: #707070;width: 160px;height: 30px;border: 1px solid #ced4da;border-radius: 0.25rem;"
                class="text-center" />
            </template>
            <template v-else>
              {{ data.value }}
            </template>
          </template>
        </commonTable>

        <div class="text-end mt-3">
          <template v-if="!mod">
            <button type="button" class="btn p-0"
              style="color: #fff;background-color: #4b8c80;width: 6rem;height: 2rem;font-size: 1.125rem;"
              @click="updateRecord">
              進行修改
            </button>
          </template>
          <template v-if="mod">
            <button type="button" class="btn p-0 me-2"
              style="color: #fff;background-color: #4b8c80;width: 6rem;height: 2rem;font-size: 1.125rem;"
              @click="updateRecord">
              取消修改
            </button>
            <button type="button" class="btn p-0"
              style="color: #fff;background-color: #4b8c80;width: 6rem;height: 2rem;font-size: 1.125rem;"
              @click="checkUpdate">
              確認修改
            </button>
          </template>
        </div>
      </template>
    </div>
    <div class="col-1"></div>
  </div>
</template>

<script>
import commonQueryInput from "@/components/commonQueryInput.vue";
import stackBar from "@/components/stackBar.vue";
import commonTable from "@/components/commonTable.vue";
import { computed, inject, ref, watch } from "vue";
import { useStore } from "vuex";
export default {
  components: {
    commonQueryInput,
    stackBar,
    commonTable,
  },
  setup() {
    const store = useStore();

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );
    const oper = computed(() => store.getters["selectOptions/get_htProcess"]);
    const device = computed(() => store.getters["selectOptions/get_device"]);

    const account = ref(loginData.value.account);
    const username = ref(loginData.value.username);

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
      set_device: (payload) => {
        store.dispatch("selectOptions/set_device", payload);
      },
    };

    const path = inject("path");
    const multiInputVal = ref();
    const multiInputItems = ref([
      {
        key: "oper",
        label: "製程",
        type: "select",
        checkEmpty: true,
        disableText: "-- 選擇製程 --",
        options: oper,
      },
      {
        key: "deviceID",
        label: "機台",
        type: "select",
        bindKey: "oper",
        checkEmpty: false,
        disableText: "-- 選擇機台 --",
        disableLock: false,
        bindOptions: device,
      },
    ]);
    const immediateMultiInputVal = ref();

    const alarmSettingData = ref([]);
    const alarmSettingOptions = [
      { value: "Y", text: "開" },
      { value: "N", text: "關" }
    ];
    const condOptions = ref({
      // operation: {
      //   type: "N",
      //   options: [
      //     {
      //       text: "停止運轉",
      //       value: "shut_down"
      //     }
      //   ]
      // },
      // number: {
      //   type: "Y",
      //   options: [
      //     {
      //       text: "正負範圍(含)",
      //       value: "btwn_equal"
      //     },
      //     {
      //       text: "正負範圍(不含)",
      //       value: "btwn_n_equal"
      //     },
      //     {
      //       text: "低於(含)",
      //       value: "minus_equal"
      //     },
      //     {
      //       text: "低於(不含)",
      //       value: "minus_n_equal"
      //     },
      //     {
      //       text: "高於(含)",
      //       value: "plus_equal"
      //     },
      //     {
      //       text: "高於(不含)",
      //       value: "plus_n_equal"
      //     }
      //   ]
      // }
    });

    //警示參數設定資訊
    const heatAlarmSettingFields = [
      {
        key: "deviceName",
        label: "機台編號",
        thStyle: {
          "min-width": "110px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "lightName",
        label: "警示燈名稱",
        thStyle: {
          "min-width": "220px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "senName",
        label: "參數名稱",
        thStyle: {
          "min-width": "220px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "condName",
        label: "條件",
        thStyle: {
          "min-width": "220px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "value",
        label: "數值",
        thStyle: {
          "min-width": "220px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const heatAlarmSettingItems = ref([]);

    const queryData = ref([]);
    const queryStatus = ref(false);

    const setReturnDate = (mainQueryResponse = '') => {
      if (typeof mainQueryResponse === "string") {
        queryStatus.value = false;
        alarmSettingData.value = [];
        heatAlarmSettingItems.value = [];
        condOptions.value = {};
        queryData.value = [];
        return;
      }
      console.log(mainQueryResponse);
      queryStatus.value = true;
      mod.value = false;
      alarmSettingData.value = mainQueryResponse[0]["alarmSettingData"];
      heatAlarmSettingItems.value = mainQueryResponse[0]["sourceData"];
      condOptions.value = mainQueryResponse[0]["condOptions"];
      queryData.value = mainQueryResponse[0]["queryData"];
    }
    //watch 按查詢鍵回傳所有輸入框的值
    watch(
      multiInputVal,
      (newValue) => {
        methods.triggerLoadingBar();
        let params = {};
        params["webPage"] =
          sideNavPath.value.length != 0
            ? sideNavPath.value[sideNavPath.value.length - 1]
            : null;
        params["user"] = loginData.value.account;
        params["vuePage"] = path.value;
        console.log(path.value);
        params["methods"] = "POST";
        params["whichFunction"] = "MainQuery";
        params["oper"] = newValue["oper"];
        params["deviceID"] = newValue["deviceID"];
        console.log(params);
        methods.axiosAction(params).then(() => {
          console.log(axiosResult.value);
          let result = axiosResult.value;
          let response = result.Response;
          if (response == "ok") {
            let queryTableData = result.QueryTableData;
            setReturnDate(queryTableData);
          } else {
            if (response == null) {
              response = 'no data';
            }
            setReturnDate();
            methods.setTimeoutAlert(response);
          }
          methods.triggerLoadingBar();
        });
      },
      { deep: true }
    );

    const startTime = ref("");
    const process = ref("");
    // 查詢機台
    watch(
      immediateMultiInputVal,
      (newValue) => {
        if (newValue.oper == "" || newValue.oper == null) {
          return;
        }
        if (
          process.value == newValue.oper
        ) {
          return;
        }
        let params = {};
        params["user"] = loginData.value.account;
        params["vuePage"] = "selectoption";
        params["methods"] = "GET";
        params["whichFunction"] = "GetDeviceOption";
        if (newValue.oper != "" || newValue.oper != null) {
          params["process"] = newValue.oper;
        } else {
          params["process"] = "-";
        }
        methods.axiosAction(params).then(() => {
          let result = axiosResult.value;
          if (result["Response"] == "ok") {
            methods.set_device(result.QueryTableData.device);
            process.value = newValue.oper;
          } else {
            let returnData = {};
            returnData[params.process] = [];
            methods.set_device(returnData);
            startTime.value = "";
            process.value = "";
          }
        });
      },
      { deep: true }
    );

    const mod = ref(false);
    const modItems = ref([]);
    const modAlarmSettingData = ref([]);
    const updateRecord = () => {
      let modData = JSON.parse(JSON.stringify(heatAlarmSettingItems.value));
      modAlarmSettingData.value = JSON.parse(JSON.stringify(alarmSettingData.value));
      modItems.value = modData;
      mod.value = !mod.value;
    }

    const checkChangeInput = (position, index = null) => {
      switch (position) {
        case "value":
          console.log("value");
          let value = Number(modItems.value[index].value);
          console.log(value);
          if (value < 0 || isNaN(value)) {
            modItems.value[index].value = modItems.value[index].orgValue;
            methods.setTimeoutAlert(`數值僅能輸入正數或0，請再次確認`);
            return;
          }
          let strTemp = ".0123456789";
          for (let i = 0; i < value.length; i++) {
            if (strTemp.indexOf(value.charAt(i)) == -1) {
              modItems.value[index].value = modItems.value[index].orgValue;
              methods.setTimeoutAlert(`數值僅能輸入正數或0，請再次確認`);
              return;
            }
          }
          modItems.value[index].value = value;
          modItems.value[index].orgValue = value;
          break;

        default:
          break;
      }
    }

    const checkUpdate = () => {
      let changeSettingData = [];
      alarmSettingData.value.forEach(data => {
        if (data.ht_light_setting != data.orgHt_light_setting) {
          changeSettingData.push({
            device_name: data.deviceName,
            ht_light_setting: data.ht_light_setting
          });
        }
      });

      let changeSenSettingData = [];
      modItems.value.forEach((data, index) => {
        if (
          heatAlarmSettingItems.value[index].orgValue != data.orgValue ||
          data.cond_code != data.orgCond_code
        ) {
          changeSenSettingData.push({
            device_name: data.deviceName,
            light_code: data.light_code,
            sen_code: data.sen_code,
            cond_code: data.cond_code,
            value: data.value
          });
        }
      });

      if (changeSettingData.length == 0 && changeSenSettingData.length == 0) {
        methods.setTimeoutAlert(`設定無異動，請重新確認`);
        console.log("設定無異動，請重新確認");
        updateRecord();
        return;
      }

      console.log("有異動");

      methods.triggerLoadingBar();
      var params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = path.value;
      params["methods"] = "POST";
      params["changeUser"] = account.value;
      params["changeSettingData"] = changeSettingData;
      params["changeSenSettingData"] = changeSenSettingData;
      params["queryData"] = queryData.value;
      params["whichFunction"] = "updateAlarmSetting";
      methods.axiosAction(params).then(() => {
        methods.triggerLoadingBar();
        let result = axiosResult.value;
        if (result["Response"] == "ok") {
          if (typeof result.QueryTableData === "string") {
            return;
          }
          methods.setTimeoutAlert(`修改成功`);
          setReturnDate(result["QueryTableData"]);
        } else {
          methods.setTimeoutAlert(result.Response);
        }
      });
    }

    return {
      username,
      multiInputVal,
      multiInputItems,
      immediateMultiInputVal,
      alarmSettingData,
      alarmSettingOptions,
      condOptions,
      heatAlarmSettingFields,
      heatAlarmSettingItems,
      queryStatus,
      mod,
      modItems,
      modAlarmSettingData,
      updateRecord,
      checkChangeInput,
      checkUpdate,
    };
  },
};
</script>

<style scoped>
.alarm-light-setting {
  max-width: 4rem;
  height: 2.375rem;
  line-height: 2.375rem;
  font-size: 0.875rem;
  padding-left: 14px;
}
</style>
